/** ログインできなかった理由。文言はこのモジュールで表示用に変換する */
export type AuthErrorReason = "unregistered" | "lookupFailed";

const MESSAGES: Record<AuthErrorReason, string> = {
  unregistered:
    "このアカウントは招待されていません。管理者に招待を依頼してください。",
  // 原因は利用者側で判断できないので、再試行と問い合わせ先だけを案内する
  lookupFailed:
    "ログインできませんでした。もう一度お試しください。解消しない場合は管理者にお知らせください。",
};

export function toAuthErrorMessage(reason: AuthErrorReason): string {
  return MESSAGES[reason];
}
